export function StampLogo({ size = 40 }: { size?: number }) {
  return (
    <img
      src="/assets/logo-stamp.png"
      width={size}
      height={size}
      alt="Mark & Post"
      style={{ borderRadius: "50%", display: "block" }}
    />
  );
}
